import { SettingsManager as BaseSettingsManager } from '@bn-games/settings-core';
import { DEFAULT_SETTINGS, type Settings } from './types.js';

const STORAGE_KEY = 'mahjong-settings';

function merge(stored: Record<string, unknown>, defaults: Settings): Settings {
  return {
    language:
      stored['language'] === 'en' || stored['language'] === 'ru'
        ? stored['language']
        : defaults.language,
    theme: stored['theme'] === 'greenFelt' ? stored['theme'] : defaults.theme,
    coachEnabled:
      typeof stored['coachEnabled'] === 'boolean'
        ? stored['coachEnabled']
        : defaults.coachEnabled,
    variant:
      stored['variant'] === 'simplified' || stored['variant'] === 'classical'
        ? stored['variant']
        : defaults.variant,
    classicalStartingPoints:
      typeof stored['classicalStartingPoints'] === 'number'
        ? stored['classicalStartingPoints']
        : defaults.classicalStartingPoints,
    turnStartSound:
      typeof stored['turnStartSound'] === 'boolean'
        ? stored['turnStartSound']
        : defaults.turnStartSound,
  };
}

export class SettingsManager extends BaseSettingsManager<Settings> {
  constructor() {
    super(STORAGE_KEY, DEFAULT_SETTINGS, merge);
  }
}
